import { defineMessage } from '@libjs-pdlocalization/components/utils';
// We use isShuffle flag for random position of values in select field

export enum CompanySize {
  EMPTY = '',
  SOLO = '1',
  MICRO = '2-10',
  SMALL = '11-50',
  MEDIUM_LOW = '51-200',
  MEDIUM_HIGH = '201-500',
  LARGE = '501-1000',
  ENTERPRISE = '1001+',
}

export const COMPANY_SIZES = [
  {
    value: CompanySize.SOLO,
    label: defineMessage('Solo'),
  },
  {
    value: CompanySize.MICRO,
    label: '2\u002D10',
  },
  {
    value: CompanySize.SMALL,
    label: '11\u002D50',
  },
  {
    value: CompanySize.MEDIUM_LOW,
    label: '51\u002D200',
  },
  {
    value: CompanySize.MEDIUM_HIGH,
    label: '201\u002D500',
  },
  {
    value: CompanySize.LARGE,
    label: '501\u002D1000',
  },
  {
    value: CompanySize.ENTERPRISE,
    label: '1001+',
  },
];

export const CRMS_OPTIONS = [
  {
    value: 'HubSpot CRM',
    label: defineMessage('HubSpot CRM'),
    isShuffle: true,
  },
  {
    value: 'Salesforce',
    label: 'Salesforce',
    isShuffle: true,
  },
  {
    value: 'Pipedrive',
    label: 'Pipedrive',
    isShuffle: true,
  },
  {
    value: 'Base',
    label: defineMessage('Zendesk Sell (formerly Base)'),
    isShuffle: true,
  },
  {
    value: 'Microsoft Dynamics',
    label: 'Microsoft Dynamics',
    isShuffle: true,
  },
  {
    value: 'Zoho',
    label: defineMessage('Zoho CRM'),
    isShuffle: true,
  },
  {
    value: 'Freshsales CRM',
    label: defineMessage('Freshsales CRM'),
    isShuffle: true,
  },
  {
    value: 'ProsperWorks',
    label: defineMessage('Copper (formerly ProsperWorks)'),
    isShuffle: true,
  },
  {
    value: 'Nutshell',
    label: 'Nutshell',
    isShuffle: true,
  },
  {
    value: 'Insightly',
    label: 'Insightly',
    isShuffle: true,
  },
  {
    value: 'Sugar',
    label: defineMessage('Sugar CRM'),
    isShuffle: true,
  },
  {
    value: 'Monday.com',
    label: 'Monday.com',
    isShuffle: true,
  },
  {
    value: 'Other',
    label: defineMessage('Other'),
    isShuffle: false,
  },
  {
    value: 'Still looking for a CRM',
    label: defineMessage('Still looking for a CRM'),
    isShuffle: false,
  },
  {
    value: "Don't have a CRM",
    label: defineMessage("Don't have a CRM"),
    isShuffle: false,
  },
];

export const TEAM = {
  SALES: 'sales',
  MARKETING: 'marketing',
  CUSTOMER_SUPPORT: 'customer_support',
  FINANCE: 'finance',
  HR: 'hr',
  IT_OPS: 'it_ops',
  LEGAL: 'legal',
  RESEARCH_AND_DEVELOPMENT: 'research_development',
  OWNER: 'owner',
  OTHER: 'other',
};

export const TEAM_OPTIONS = [
  {
    value: TEAM.SALES,
    label: defineMessage('Sales'),
    isShuffle: true,
  },
  {
    value: TEAM.MARKETING,
    label: defineMessage('Marketing'),
    isShuffle: true,
  },
  {
    value: TEAM.CUSTOMER_SUPPORT,
    label: defineMessage('Customer Success / Support'),
    isShuffle: true,
  },
  {
    value: TEAM.FINANCE,
    label: defineMessage('Finance'),
    isShuffle: true,
  },
  {
    value: TEAM.HR,
    label: defineMessage('HR'),
    isShuffle: true,
  },
  {
    value: TEAM.IT_OPS,
    label: defineMessage('Operations & IT'),
    isShuffle: true,
  },
  {
    value: TEAM.LEGAL,
    label: defineMessage('Legal'),
    isShuffle: true,
  },
  {
    value: TEAM.RESEARCH_AND_DEVELOPMENT,
    label: defineMessage('R&D'),
    isShuffle: true,
  },
  {
    value: TEAM.OWNER,
    label: defineMessage('Owner / CEO'),
    isShuffle: true,
  },
  {
    value: TEAM.OTHER,
    label: defineMessage('Other'),
    isShuffle: false,
  },
];

export const WHAT_BROUGHT_YOU_TO_PANDADOC = {
  PROPOSALS: 'Proposals',
  CONTRACT: 'Contracts',
  ELECTRONIC_SIGNATURES: 'Electronic Signatures',
  QUOTES: 'Quotes',
  API: 'API',
  OTHER: 'other',
};

export const WHAT_BROUGHT_YOU_TO_PANDADOC_OPTIONS = [
  {
    value: 'Proposals',
    label: defineMessage('Proposals'),
    isShuffle: true,
  },
  {
    value: 'Contracts',
    label: defineMessage('Contracts'),
    isShuffle: true,
  },
  {
    value: 'Electronic Signatures',
    label: defineMessage('Electronic Signatures'),
    isShuffle: true,
  },
  {
    value: 'Quotes',
    label: defineMessage('Quotes'),
    isShuffle: true,
  },
  {
    value: 'API',
    label: defineMessage('API'),
    isShuffle: true,
  },
  {
    value: 'Other',
    label: defineMessage('Other'),
    isShuffle: false,
  },
];

export const ESIGN_COMPETITOR_OPTIONS = [
  {
    value: 'DocuSign',
    label: defineMessage('DocuSign'),
    isShuffle: true,
  },
  {
    value: 'Dropbox Sign (formerly HelloSign)',
    label: defineMessage('Dropbox Sign (formerly HelloSign)'),
    isShuffle: true,
  },
  {
    value: 'Adobe Acrobat Sign',
    label: defineMessage('Adobe Acrobat Sign'),
    isShuffle: true,
  },
  {
    value: 'signNow',
    label: defineMessage('signNow'),
    isShuffle: true,
  },
  {
    value: 'Juro',
    label: defineMessage('Juro'),
    isShuffle: true,
  },
  {
    value: 'GetAccept',
    label: defineMessage('GetAccept'),
    isShuffle: true,
  },
  {
    value: 'Other',
    label: defineMessage('Other'),
    isShuffle: false,
  },
  {
    value: 'None',
    label: defineMessage('None'),
    isShuffle: false,
  },
];
